import { render, staticRenderFns } from "./LayoutCenter.vue?vue&type=template&id=48fa6f07&"
import script from "./LayoutCenter.vue?vue&type=script&lang=js&"
export * from "./LayoutCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports